module.exports = __webpack_public_path__ + "img/add_field.473b6729.svg";